import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import './TransparentButton.scss';

class TransparentButton extends Component {
    render() {
        return (
            <Button
                disableRipple
                disabled={this.props.disabled}
                onClick={this.props.onClick}
                className={'transparent-button'}
            >
                {this.props.children}
            </Button>
        );
    }
}

export default TransparentButton;
